import script from "./MyMessagesView.vue?vue&type=script&setup=true&lang=js"
export * from "./MyMessagesView.vue?vue&type=script&setup=true&lang=js"

import "./MyMessagesView.vue?vue&type=style&index=0&id=74d8dad6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74d8dad6"]])

export default __exports__